import { CreateNoteUsingCalendarEventOperation } from "@/store/sync/operations/calendars/CreateNoteUsingCalendarEventOperation";
import { AcceptNoteSuggestionOperation } from "@/store/sync/operations/notes/AcceptNoteSuggestionOperation";
import { UpdateNoteContentOverwritingFullStateDestructivelyOperation } from "@/store/sync/operations/notes/UpdateNoteContentOverwritingFullStateDestructivelyOperation";
import { UpdateNoteContentUsingDiffOperation } from "@/store/sync/operations/notes/UpdateNoteContentUsingDiffOperation";
import { SyncOperationGeneric } from "@/store/sync/operations/types";
import { orderBy } from "lodash-es";

export const getQueuedDocumentUpdates = ({
  operationsByModelId,
  id,
}: {
  operationsByModelId: Map<string, SyncOperationGeneric[]>;
  id: string;
}) => {
  const pendingOperations = orderBy(
    operationsByModelId.get(id) || [],
    "locally_committed_at",
    "asc"
  );
  return getQueuedDocumentUpdatesForOperations({ operations: pendingOperations, id });
};

export const getQueuedDocumentUpdatesForOperations = ({
  operations,
  id,
}: {
  operations: SyncOperationGeneric[];
  id: string;
}) => {
  const output: { id: string; encodedContentDiff: string; isDestructive?: boolean }[] = [];
  for (const operation of operations) {
    if (operation.operationKind === "UPDATE_NOTE_CONTENT_OVERWRITING_FULL_STATE_DESTRUCTIVELY") {
      const op = operation as UpdateNoteContentOverwritingFullStateDestructivelyOperation;
      if (op.payload.id !== id) continue;
      output.splice(0, output.length, {
        id: op.id,
        encodedContentDiff: op.payload.encoded_content,
        isDestructive: true,
      });
    } else if (operation.operationKind === "UPDATE_NOTE_CONTENT_USING_DIFF") {
      const op = operation as UpdateNoteContentUsingDiffOperation;
      if (op.payload.id !== id || op.payload.encoded_content_diff.length === 0) continue;
      output.push({ id: op.id, encodedContentDiff: op.payload.encoded_content_diff });
    } else if (operation.operationKind === "ACCEPT_NOTE_SUGGESTION") {
      const op = operation as AcceptNoteSuggestionOperation;
      if (op.payload.note_id !== id) continue;
      output.push({ id: op.id, encodedContentDiff: op.payload.encoded_content_diff });
    } else if (operation.operationKind === "CREATE_NOTE_USING_CALENDAR_EVENT") {
      const op = operation as CreateNoteUsingCalendarEventOperation;
      if (op.payload.note_id !== id) continue;
      output.push({ id: op.id, encodedContentDiff: op.payload.encoded_content });
    }
  }
  return output;
};
